export class Worker {}
export const parentPort = null;
//# sourceMappingURL=worker_threads-browser.js.map